<template>
  <div class="wrapper">
    <div class="breadcrumb">{{$t("about.info.breadcrumb")}}</div>
    <div class="container index">
      <div class="box">
        <img src="~assets/about/info.png"/>
      </div>
      <div class="text" v-html='$t("about.info.text")'></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Info',
  data () {
    return {
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper
    width 78%
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
    .container
    .idea
      .text
        box-sizing border-box
        padding 0 23px
        margin-top 20px
        width 100%
</style>



// WEBPACK FOOTER //
// src/pages/about/components/Info.vue